import { gql } from '@apollo/client';
import { IMAGE_FRAGMENT } from './image.gql';
import { COUNTRY_FRAGMENT } from './country.gql';

export const DESTINATION_CITY_FRAGMENT = gql`
    ${COUNTRY_FRAGMENT}
    ${IMAGE_FRAGMENT}
    fragment DestinationCityType on DestinationCityType {
        id
        name
        country {
            ...CountryType
        }
        images {
            ...ImageType
        }
    }
`;

export const DESTINATION_FRAGMENT = gql`
    ${DESTINATION_CITY_FRAGMENT}
    ${IMAGE_FRAGMENT}
    fragment DestinationType on DestinationType {
        id
        destination
        city {
            ...DestinationCityType
        }
        description
        slug
        visits
        images {
            ...ImageType
        }
    }
`;

// export const PACKAGES_ORIGIN_FRAGMENT = gql`
//     ${COUNTRY_FRAGMENT}
//     fragment TouristPackageOriginType on TouristPackageOriginType {
//         id
//         origin {
//             ...CountryType
//         }
//         availableFrom
//         visa
//         visaPrice
//         price
//     }
// `;

// export const SERVICES_FRAGMENT = gql`
//     fragment ServiceType on ServiceType {
//         id
//         name
//         iconVariants {
//             id
//             name
//             theme
//         }
//     }
// `;

// export const PLACE_INTEREST_FRAGMENT = gql`
//     fragment PlaceInterestType on PlaceInterestType {
//         id
//         name
//         icon
//     }
// `;

// export const EXPERIENCE_REQUIREMENT_FRAGMENT = gql`
//     fragment ExperienceRequirementType on ExperienceRequirementType {
//         id
//         name
//         icon
//     }
// `;

// export const LODGINGS_FRAGMENT = gql`
//     ${SERVICES_FRAGMENT}
//     ${PLACE_INTEREST_FRAGMENT}
//     ${EXPERIENCE_REQUIREMENT_FRAGMENT}
//     ${LOCATION_FRAGMENT}
//     fragment LodgingsType on LodgingsType {
//         id
//         name
//         services {
//             ...ServiceType
//         }
//         placesInterest {
//             ...PlaceInterestType
//         }
//         requirements {
//             ...ExperienceRequirementType
//         }
//         address
//         phone
//         email
//         contactName
//         description
//         enterAfter
//         enterBefore
//         roomQty
//         bathQty
//         category
//         lodgingType
//         coordinates {
//             ...CoordinatePointType
//         }
//     }
// `;

// export const PACKAGE_LODGINGS_FRAGMENT = gql`
//     fragment TouristPackageLodgingType on TouristPackageLodgingType {
//         id
//         promotional
//         isActive
//     }
// `;

// export const FRECUENCY_FRAGMENT = gql`
//     fragment FrequencyFieldType on FrequencyFieldType {
//         frequency
//         recurrenceRules
//     }
// `;

// export const PACKAGE_SERVICE_FRAGMENT = gql`
//     ${SERVICES_FRAGMENT}
//     ${FRECUENCY_FRAGMENT}
//     fragment TouristPackageServiceType on TouristPackageServiceType {
//         id
//         service {
//             ...ServiceType
//         }
//         promotional
//         price
//         frecuency {
//             ...FrequencyFieldType
//         }
//     }
// `;

// export const BAGGAGE_FRAGMENT = gql`
//     fragment BaggageType on BaggageType {
//         id
//         name
//         qty
//         weightKg
//     }
// `;

// export const PACKAGE_BAGGAGE_FRAGMENT = gql`
//     ${BAGGAGE_FRAGMENT}
//     fragment TouristPackageBaggageKind on TouristPackageBaggageKind {
//         id
//         baggage {
//             ...BaggageType
//         }
//         type
//         price
//         comments
//     }
// `;

// export const PACKAGE_RELATED_FRAGMENT = gql`
//     ${COUNTRY_FRAGMENT}
//     fragment RelatedType on TouristPackageObjectType {
//         related {
//             id
//             name
//             price
//             type
//             images {
//                 ...ImageType
//             }
//             origins {
//                 id
//                 origin {
//                     ...CountryType
//                 }
//                 availableFrom
//                 visa
//                 visaPrice
//                 price
//             }
//             destination {
//                 id
//                 destination
//                 description
//                 slug
//                 visits
//             }
//             lodgings {
//                 id
//             }
//             baggage {
//                 id
//                 type
//                 price
//             }
//         }
//     }
// `;

export const PACKAGES_FRAGMENT = gql`
    ${IMAGE_FRAGMENT}
    ${COUNTRY_FRAGMENT}
    fragment TouristPackageObjectType on TouristPackageObjectType {
        id
        name
    }
`;
